// 自定义指令
import Vue from 'vue'

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

Vue.directive('autoHeight', {
  update: function (el) {
    el.style.height = "1px";
    el.style.height = (el.scrollHeight) + "px";
  },
  inserted: function (el) {
    el.style.height = "1px";
    el.style.height = (el.scrollHeight) + "px";
  },
  componentUpdated: function (el) {
    el.style.height = "1px";
    el.style.height = (el.scrollHeight) + "px";
  },
})

Vue.directive('drag', {
  bind(el, binding) {
    const isMobile = /Android|iPhone|iPad|iPod|Mobile|Windows Phone|BlackBerry/i.test(navigator.userAgent);
    if (isMobile) {
      var divLeft, divTop, startX, startY; //盒子的坐标
      el.addEventListener('touchstart', function (event) {
        divLeft = el.offsetLeft;
        divTop = el.offsetTop;
        startX = event.targetTouches[0].pageX;
        startY = event.targetTouches[0].pageY;
      });
      el.addEventListener('touchmove', function (event) {
        //用移动后手指坐标-移动前手指坐标=移动距离
        var moveX = event.targetTouches[0].pageX - startX;
        var moveY = event.targetTouches[0].pageY - startY;
        //移动距离+盒子原来位置=现在位置
        if (binding.value == 'vertical') {
          el.style.top = divTop + moveY + 'px';
          el.style.bottom = "inherit";
        } else {
          el.style.left = divLeft + moveX + 'px';
          el.style.right = "inherit";
          el.style.top = divTop + moveY + 'px';
          el.style.bottom = "inherit";
        }
        //阻止默认的屏幕滚动
        event.preventDefault();
      })
    } else {
      el.onmousedown = function (event) {
        let disX = event.clientX - el.offsetLeft;
        let disY = event.clientY - el.offsetTop;
        let x = event.clientX - disX;
        let y = event.clientY - disY;
        document.onmousemove = function (event) {
          el.style.cursor = "move";
          x = event.clientX - disX;
          y = event.clientY - disY;
          if (binding.value == 'vertical') {
            el.style.top = y + 'px'; // 移动元素
          } else {
            el.style.top = y + 'px'; // 移动元素
            el.style.left = x + 'px'; // 移动元素
          }
          el.dispatchEvent(new CustomEvent('drag-start', {
            detail: { x, y }
          }));
        };
        document.onmouseup = function (event) {
          // 移除事件监听器
          el.style.cursor = "";
          document.onmousemove = null;
          document.onmouseup = null;
          let timer = setTimeout(() => {
            el.dispatchEvent(new CustomEvent('drag-end', {
              detail: { x, y }
            }));
            clearTimeout(timer);
          }, 200);
        };
      };
    }

  },
})

Vue.directive('maxheight', {
  update: function (el, data) {
    var id = el.getAttribute("data-id");
    if (!id) {
      return;
    }
    document.getElementById(id).onclick = () => {
      el.style.maxHeight = el.scrollHeight + 'px';
      el.style.transition = "max-height 0.3s";
      el.removeChild(document.getElementById(id));
    }
  },
  inserted: function (el, data) {
    if (!(data.value > 0)) {
      return;
    }
    el.style["max-height"] = data.value + 'px';
    el.style["position"] = "relative";
    el.style["overflow"] = "hidden";
    // el.style["text-overflow"] = "ellipsis";
    // el.style["display"] = "-webkit-box";
    // el.style["-webkit-line-clamp"] = parseInt(data.value / 20);
    // el.style["line-clamp"] = parseInt(data.value / 20);
    // el.style["-webkit-box-orient"] = "vertical";
    setTimeout(() => {
      // if (el.scrollHeight < data.value) {
      //   return;
      // }
      var id = ("id" + Math.random()).replace(".", "_");
      var div = document.createElement("div");
      div.innerHTML = "查看更多";
      div.setAttribute("id", id);
      div.setAttribute("style", "position:absolute;z-index:10;bottom:0;right:0;background-color: #fff;padding:2px 5px;display: flex;align-items: center;justify-content: center;cursor: pointer;color: #777;font-size: 0.92em");
      el.appendChild(div);
      div.setAttribute("data-id", id);
      document.getElementById(id).onclick = () => {
        el.style.maxHeight = el.scrollHeight + 'px';
        el.style.transition = "all 0.3s";
        // el.style["-webkit-line-clamp"] = "inherit";
        // el.style["line-clamp"] = "inherit";
        el.removeChild(document.getElementById(id));
      }
    })
  },
  componentUpdated: function (el, data) {
    var id = el.getAttribute("data-id");
    if (!id) {
      return;
    }
    document.getElementById(id).onclick = () => {
      el.style.maxHeight = el.scrollHeight + 'px';
      el.style.transition = "max-height 0.3s";
      el.removeChild(document.getElementById(id));
    }
  },
})

function getTextWidth(text, cssObj = {}) {
  // 创建一个隐藏的临时元素，用于计算文本宽度
  var tempElement = document.createElement("span");
  tempElement.style.visibility = "hidden";
  tempElement.style.whiteSpace = "pre"; // 保持空格和换行的格式
  tempElement.style.display = "inline-block";
  for (let key in cssObj) {
    tempElement.style[key] = cssObj[key];
  }
  tempElement.textContent = text;
  // 将临时元素添加到文档中
  document.body.appendChild(tempElement);
  // 获取文本的宽度
  var width = tempElement.offsetWidth;
  // 从文档中移除临时元素
  document.body.removeChild(tempElement);
  return width + 2;
}

Vue.directive('inputWidth', {
  update: function (el, data) {
    var textWidth = getTextWidth(el.value, data.value);
    el.style.width = textWidth + 2 + "px";
  },
  inserted: function (el, data) {
    var textWidth = getTextWidth(el.value, data.value);
    el.style.width = textWidth + 2 + "px";
  },
  componentUpdated: function (el, data) {
    var textWidth = getTextWidth(el.value, data.value);
    el.style.width = textWidth + 2 + "px";
  },
})

Vue.directive('hidden', {
  inserted: function (el, data) {
    if(data.value){
      el.style.visibility = "hidden";
    }
  },
})


// WEBPACK FOOTER //
// ./src/utils/directive.js